export enum PlanNames {
    GoToMeeting = 'GoToMeeting',
    GoToWebinar = 'GoToWebinar',
    GoToTraining = 'GoToTraining',
}
